import { UntypedFormBuilder } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { PagingSearchCriteria } from "src/app/shared/model/PagingSearchCriteria";

export interface GetSentPortalMessagesByUserCriteria extends PagingSearchCriteria {
    portalUserId: string | null;
    sentFromDate: Date;
    sentToDate: Date;
    text: string;
}

export class GetSentPortalMessagesByUserCriteriaFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, searchCriteria: GetSentPortalMessagesByUserCriteria)  {
  
      return fb.group(
        {
            portalUserId: [searchCriteria.portalUserId],
            sentFromDate: [this.dateValue(searchCriteria.sentFromDate)],
            sentToDate: [this.dateValue(searchCriteria.sentToDate)],
            text: [searchCriteria.text],
        }
      );
    }

    static initGetSentPortalMessagesByUserCriteria(): GetSentPortalMessagesByUserCriteria {
        
        const sentToDate = new Date();
        sentToDate.setDate(sentToDate.getDate() - 14);

      return {
        portalUserId:null,
        sentFromDate: sentToDate,
        sentToDate: new Date(),
        text: '',
        pageNumber: 1,
        rowsPerPage: 25,
        sortDirection: 'DESC',
        sortColumn: '',
        
      };
    }
  }